import styled from 'styled-components';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { PrimaryCta, SecondaryCta } from '../../Cta';
import RichText from '../../RichText';

export type FeatureHeadingStyleProps = {
  addImageToHeadingSpacingOnMobile?: boolean;
};

export const Heading = styled.h2<FeatureHeadingStyleProps>`
  ${fonts.headingMedium};

  margin-bottom: ${spacing(2)};

  margin-top: ${({ addImageToHeadingSpacingOnMobile }) =>
    addImageToHeadingSpacingOnMobile ? spacing(3) : 0};

  ${mediaQuery.tabletPortrait`
    margin-top: 0;
  `}
`;

export const Subheading = styled.p`
  ${fonts.paragraphLarge}
  margin-bottom: ${spacing(2)};
`;

export const StyledPrimaryCta = styled(PrimaryCta)`
  margin-top: ${spacing(4)};
`;

export const StyledSecondaryCta = styled(SecondaryCta)`
  margin-top: ${spacing(4)};
`;

/* When the Feature doesn't have a title, we need to apply styling to the RichText to have appropriate top-margin.
 * In this scenario, the RichText is the first child, and this styling gets applied.
 * We also need to add a specific case for lists, since lists have a nested li as with margin, so we need to remove
 * that top margin if a list is used as the first thing in the RichText.
 */
export const StyledRichText = styled(RichText)<{
  addImageToFirstChildSpacingOnMobile?: boolean;
}>`
  &:first-child > :first-child {
    margin-top: ${({ addImageToFirstChildSpacingOnMobile }) =>
      addImageToFirstChildSpacingOnMobile ? spacing(3) : 0};

    ${mediaQuery.tabletPortrait`
      margin-top: 0;
    `}

    & > li:first-child {
      margin-top: 0;
    }
  }
`;
